import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-site",
  "use": "icon-site-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-site\"><path d=\"M791.9 618.1V483.6H531.3v-77.8h127.6V104.6H357.7v301.2h127.6v77.8H234.7v134.5H104.5v301.2h301.2V618.1h-125v-88.5h465.2v88.5H618.3v301.2h301.2V618.1H791.9zM403.7 150.6h209.2v209.2H403.7V150.6z m-44 722.8H150.5V664.1h209.2v209.3z m513.8 0H664.3V664.1h209.2v209.3z\" p-id=\"4370\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/site.svg
// module id = Bd3Y
// module chunks = 51